import { styled } from '@mui/material';

export const PanoramaOverlay = styled('div')`
  width: 100%;
  height: 100%;
  position: fixed;
  background: #333;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`;
